<div class="tripist-embed-wrapper" [ngClass]="viewMode">
    <div *ngIf="loading" class="tripist-embed-loading">
        <mat-spinner diameter="40"></mat-spinner>
    </div>
    <div *ngIf="error" class="tripist-embed-error">
        {{ error }}
    </div>
    <div
        #tripistEmbedContainer
        class="tripist-embed-container"
        [style.display]="loading || error ? 'none' : 'flex'"
    ></div>
</div>
